import React from 'react';
import { EadTree, useEadTree } from '../context/ead-context';
import { useEadDetail } from '../hooks/ead-detail-hook';

import { LinearProgress } from '@material-ui/core';
import LoaderOverlay from 'components/loader/loader-overlay';
import ControlButtons from '../control-buttons';
import VirtualTree from './virtual-list';
function EadDetailList({ id }: { id: string }) {
  const response = useEadDetail(id);
  const tree = useEadTree(response.data);
  return (
    <EadTree.Provider value={{ ...tree }}>
      {response.isLoading && <LoaderOverlay />}
      <div style={{ color: 'white' }}>
        <EadTree.Consumer>
          {({ loading }) => (
            <div style={{ position: 'absolute', top: 0, width: '100%' }}>
              {loading && <LinearProgress />}
            </div>
          )}
        </EadTree.Consumer>
        <ControlButtons />
        {/* <VirtualTree data={flatEadTest ?? []} /> */}
        <VirtualTree data={tree.flatEad ?? []} />
      </div>
    </EadTree.Provider>
  );
}

export default EadDetailList;
